export default "__VITE_ASSET__C_XGe0bi__"